/*global chrome*/
import React, { useEffect, useState } from 'react';
import { Button, Flex, Alert, } from '@smarterservices/smarter-ui';
import StepInstructions from '../Common/StepInstructions';
import { startRecording } from './api';
import { sendMessageToExtension } from '../../helpers/helpers';
import DualPane from '../DualPane';
import { usePaneViewer } from '../PaneViewer';
import Loader from '../Common/Loader';
import { useAppStore } from '../../stores/app';

const ShareScreen = ({ stepData, setIsTaskComplete, inSession, setStepMetadata }) => {
  // manage state if the button is clicked to share
  const [isSharing, setIsSharing] = useState(false);
  // manage state if the screen sharing is being set up after selecting a window to share
  const [isSettingUpShare, setIsSettingUpShare] = useState(false);
  // pull in onNext so we can auto advance to next step after share
  const { onNext } = usePaneViewer();

  useEffect(() => {
    const checkIfAlreadyPublished = async () => {

      const isAlreadyPublished = await sendMessageToExtension({
        message: 'sp_background__isTrackPublished',
        trackName: 'screen',
      });
      if (isAlreadyPublished) {
        setIsSharing(true);
        setIsTaskComplete(true);
        // now auto advance to next step since screen has been shared...
        onNext();
      }
    };
    checkIfAlreadyPublished();
  }, []);

  const minimizeAllWindows = async () => {
    const response = await sendMessageToExtension({
      message: 'sp_background__minimizeAllWindows',
    });
  };

  const handleShareScreen = async () => {
    try {
      if (!chrome.runtime || !window.chrome) {
        // Chrome is not enabled... extension may be disabled
        window.location.reload();
        return;
      }

      // Add the query params back to the URL in the event the user needs to relaunch after modifying security settings...
      useAppStore.getState().restoreLaunchParams();

      // Disable the button to share again if the popup is already raised
      setIsSharing(true);

      console.log('Starting screen share...');
      // Start sharing the screen to the extension
      const response = await sendMessageToExtension({
        message: 'sp_background__startScreenShare',
      });

      // Remove the query params from the URL
      useAppStore.getState().removeLaunchParams();

      if (response === null) {
        // no listener is set up on the extension
        window.location.reload();
        return;
      }

      setIsSharing(response);

      // Bring the tab/window back into focus in case it was minimized to find the dialog...
      await sendMessageToExtension({
        message: 'sp_background__focusTab',
        state: "maximized"
      });

      if (response) {
        // Screen was successfully shared, so lets start the recording (not in session, as it would already be started)
        if (!inSession) {
          try {

            setIsSettingUpShare(true);

            // Start recording/egress...
            await startRecording();

            //TODO: We need to go into a loop here to check if the recording is started b/c we cannot let the user proceed without recording

            setIsTaskComplete(true);

            // now auto advance to next step since screen has been shared...
            onNext();
            setStepMetadata({});

          } catch (error) {
            const response = await sendMessageToExtension({
              message: 'sp_background__stopScreenShare',
            });
            // TODO: Figure out what we are going to alert/log...
            console.log(response);
          }
        } else {
          // if we are in session, lets show the next button now.
          onNext();
          setIsTaskComplete(true);
          setIsSettingUpShare(true);
        }
      } else {
        //TODO: We need to decide on what we are going to do here.
        console.log("Screen share failed");
        setIsSettingUpShare(false);
      }
    } catch (error) {
      console.error('Error occurred handling screen share:', { error });
      window.location.reload();
    }
  };

  return (
    <DualPane
      leftPane={
        <StepInstructions
          title="Instructions"
          instructions={stepData?.body}
        />
      }
      rightPane={
        <Flex
          direction="column"
          alignItems="center"
          justifyContent="center"
          height="100%"
        >
          {isSettingUpShare ?
            <Loader text='Configuring screen sharing...' />
            :
            (
              <>
                {isSharing ? (
                  <>
                    <StepInstructions
                      title="Screen Sharing Help"
                      instructions={stepData?.screenSharingOpenText}
                    />
                    <Button
                      color="primary"
                      size="medium"
                      onClick={minimizeAllWindows}
                    >
                      {stepData.minimizeAllButtonText}
                    </Button>
                  </>
                ) : (
                  <Button
                    color="primary"
                    size="medium"
                    onClick={handleShareScreen}
                    interaction={isSharing ? 'disabled' : 'enabled'}
                  >
                    {stepData.button}
                  </Button>
                )}

              </>
            )
          }
        </Flex>
      }
    />
  );
};

export default ShareScreen;